const stockEntityDefaultLabels = {
  name: "Имя",
  type: "Тип",
  barcode: "Штрихкод",
  vendor_code: "Артикул",
};

const cloth = {
  labels: {
    ...stockEntityDefaultLabels,
    additional_info: "Дополнительно",
    text_description: "Текстовое описание",
    color: "Цвет",
    structure: "Состав",
    width: "Ширина",
    winding: "Намотка",
    density: "Плотность",
    vendor_code: "Ткани",
    provider_vendor_code: "Поставщика",
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
    additional_info: 120,
    text_description: 500,
    color: 40,
    structure: 500,
    width: 60,
    winding: 60,
    density: 60,
    provider_vendor_code: 15,
  },
};

const cutOfClothes = {
  labels: {
    ...stockEntityDefaultLabels,
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
  },
};

const expendableMaterial = {
  labels: {
    ...stockEntityDefaultLabels,
    text_description: "Текстовое описание",
    length: "Длина (намотка)",
    thickness: "Толщина",
    structure: "Материал (состав)",
    weight: "Вес",
    volume: "Объем",
    color: "Цвет",
    brand: "Бренд",
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
    text_description: 500,
    length: 75,
    thickness: 75,
    structure: 500,
    weight: 75,
    volume: 75,
    color: 40,
    brand: 75,
  },
};

const stationery = {
  labels: {
    ...stockEntityDefaultLabels,
    stationery_subtype: "Подтип",
    color: "Цвет",
  },
  maxlength: {
    name: 75,
    type: 75,
    stationery_subtype: 75,
    barcode: 15,
    vendor_code: 15,
    color: 40,
  },
};

const promotionalProduct = {
  labels: {
    ...stockEntityDefaultLabels,
    text_description: "Текстовое описание",
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
    text_description: 500,
  },
};

const sewingAccessory = {
  labels: {
    ...stockEntityDefaultLabels,
    color: "Цвет",
    length: "Длина",
    material: "Материал",
    width: "Ширина",
    size: "Размер",
    thickness: "Толщина",
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
    color: 40,
    length: 75,
    material: 500,
    width: 60,
    size: 60,
    thickness: 75,
  },
};

const packageItem = {
  labels: {
    ...stockEntityDefaultLabels,
    text_description: "Текстовое описание",
    color: "Цвет",
    length: "Длина",
    width: "Ширина",
    height: "Высота",
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
    color: 40,
    length: 75,
    width: 60,
    height: 60,
  },
};

const product = {
  labels: {
    ...stockEntityDefaultLabels,
    subtype: "Подтип",
    gender: "Пол",
    price: "Цена",
    color: "Цвет",
    filler_material: "Материал заполнителя",
    text_description: "Текстовое описание",
    cloth_structure: "Состав ткани",
    lining_structure: "Состав подкладки",
    care_advices: "Инструкция по уходу",
    artistic_description: "Художественное описание",
    NDS: "НДС",
    season: "Сезон",
    collection: "Коллекция",
    style: "Стиль",
    amount_in_package: "Количество в упаковке",
    collar_form: "Форма воротника/горловины",
    waist: "Талия",
    clothing_type: "Вид одежды",
    details: "Детали",
    package_item: "Упаковка",
    parent: "Родитель",
    sizes_data: "Размеры",
    cut_of_clothes: "Крой",
    cloths_data: "Ткани",
    sewing_accessories_data: "Вся фурнитура",
    packages_data: "Упаковки",
    promotional_products_data: "Вся рекламная продукция",
  },
  maxlength: {
    name: 75,
    type: 75,
    barcode: 15,
    vendor_code: 15,
    subtype: 75,
    gender: 15,
    price: 35,
    text_description: 500,
    care_advices: 800,
    artistic_description: 800,
  },
};

const POSSIBLE_STATUSES = ['в работе', 'выполнен', 'отменен'];

const project = {
  labels: {
    name: "Название",
    status: "Статус",
    user_id: "Ответственный пользователь",
    products_data: "Продукты",
  },
  maxlength: {
    name: 75,
  },
  statusValues: POSSIBLE_STATUSES,
};

const purchaseOrder = {
  labels: {
    number: "Номер",
    status: "Статус",
    client_id: "Клиент",
    price: "Стоимость",
    shipping_date: "Дата отгрузки",
  },
  maxLength: {
    number: 20,
    status: 15,
    client_id: 15,
    price: 65,
    shipping_date: 30,
  },
  types: {
    number: 'text',
    price: 'text',
    shipping_date: 'date',
  },
  statusValues: POSSIBLE_STATUSES,
};

export const formsFields = {
  cloth,
  cutOfClothes,
  expendableMaterial,
  stationery,
  promotionalProduct,
  sewingAccessory,
  packageItem,
  project,
  product,
  purchaseOrder,
};



// WEBPACK FOOTER //
// ./src/stock/constants/formsFields.js